import React, { useEffect, useRef } from 'react';
import MainContent from './components/MainContent';
import './styles/FreeBoard.css';
import './styles/MarkdownTable.css';
import './styles/ClienLayout.css';
import './styles/SuccessStories.css';
import { supabase } from './services/api/client';
import { ensureValidSession } from './utils/auth';

const App = () => {
  const sessionCheckIntervalRef = useRef(null);
  const lastActivityRef = useRef(Date.now());

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'TOKEN_REFRESHED') {
      }
      if (event === 'SIGNED_OUT') {
        // 세션 체크 중지
        if (sessionCheckIntervalRef.current) {
          clearInterval(sessionCheckIntervalRef.current);
        }
      }
    });

    // 앱 시작 시 세션 유효성 체크
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session) {
      } else {
      }
    });

    // 사용자 활동 감지 (마우스, 키보드, 터치 등)
    const updateLastActivity = () => {
      lastActivityRef.current = Date.now();
    };

    const activityEvents = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'];
    activityEvents.forEach(event => {
      window.addEventListener(event, updateLastActivity, { passive: true });
    });

    // 주기적 세션 갱신 (3분마다 체크, 사용자 활동이 있을 때만)
    sessionCheckIntervalRef.current = setInterval(async () => {
      const now = Date.now();
      const timeSinceLastActivity = now - lastActivityRef.current;
      const fiveMinutes = 5 * 60 * 1000;

      // 최근 5분 이내에 활동이 있었다면 세션 갱신
      if (timeSinceLastActivity < fiveMinutes) {
        const session = await ensureValidSession();
        if (!session) {
        }
      } else {
      }
    }, 3 * 60 * 1000); // 3분마다

    // 페이지 가시성 변경 시 세션 확인 (탭 전환 후 돌아올 때)
    const handleVisibilityChange = async () => {
      if (document.visibilityState === 'visible') {
        const session = await ensureValidSession();
        if (!session) {
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      subscription.unsubscribe();

      // 세션 체크 인터벌 정리
      if (sessionCheckIntervalRef.current) {
        clearInterval(sessionCheckIntervalRef.current);
      }

      // 이벤트 리스너 정리
      activityEvents.forEach(event => {
        window.removeEventListener(event, updateLastActivity);
      });
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <MainContent />
  );
};

export default App; 